module.exports = __webpack_public_path__ + "img/overview9.7878fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/overview9.jpg
// module id = pGNL
// module chunks = 0